<div id="driver-wizard"
     class="row ">
     <div class="d-flex justify-content-between align-items-center card-title"
          id="page-title">
          <h1 *ngIf="!service.justSubscribe"
              [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>
          <h1 *ngIf="service.justSubscribe"
              [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body"
                    *ngIf="service.justSubscribe">
                    <h2 [innerHtml]="'RecordMonitoring_sub' | translator: 'base'">PSP Driver Monitoring</h2>
                    <p [innerHtml]="'RecordMonitoring_start_body1' | translator: 'base'">
                         This no cost service is available to commercial drivers only. By enrolling in the PSP Driver
                         Monitoring program, you will receive email notifications when there are additions or updates to
                         your PSP record which includes
                    </p>
                    <ul>
                         <li [innerHtml]="'RecordMonitoring_start_li_1' | translator: 'base'">
                              New crash violation and or inspection data.</li>
                         <li [innerHtml]="'RecordMonitoring_start_li_2' | translator: 'base'">
                              When a violation or inspection has dropped off of your PSP record.</li>
                         <li [innerHtml]="'RecordMonitoring_start_li_3' | translator: 'base'">
                              Your existing crash, violation, and or inspection data has been updated.
                         </li>
                    </ul>
                    <p [innerHtml]="'RecordMonitoring_start_body_Note' | translator: 'base'"
                       style="font-style: italic;">
                         Note: All PSP records include up to five-year crash violation data and three-year roadside
                         inspection history.
                    </p>
                    <p [innerHtml]="'RecordMonitoring_start_body_Enrolling' | translator: 'base'">
                         Enrolling takes only a few minutes, and you will be guided through the process to create an
                         account which allows you to monitor one or more commercial driver license. </p>
                    <p [innerHtml]="'RecordMonitoring_start_body_Opt_Out' | translator: 'base'">
                         You can opt out of PSP Driver Monitoring at any time.
                    </p>
                    <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                         <div class="btn-group"
                              role="group">
                              <a [routerLink]="'/driver/2' + (service.justSubscribe ? '/subscribe' : '')"
                                 (click)="scrollToTop()"
                                 class="btn btn-primary btn-strong"
                                 [title]="'Continue' | translator: 'base'"
                                 name="driverNext"
                                 id="driverNext">
                                   <span [innerHtml]="'Continue' | translator: 'base'">Continue</span>
                              </a>
                         </div>
                         <div class="btn-group"
                              role="group">
                              <a routerLink="/"
                                 class="btn btn-light"
                                 (click)="scrollToTop()"
                                 name="driverCancel"
                                 id="driverCancel"
                                 [innerHtml]="'Cancel' | translator: 'base'"
                                 [title]="'Cancel' | translator: 'base'">
                                   Cancel
                              </a>
                         </div>
                    </div>
               </div>
               <div class="card-body"
                    *ngIf="!service.justSubscribe">
                    <h2 [innerHtml]="'YourPSPRecord' | translator: 'base'">Your PSP Record</h2>
                    <p [innerHtml]="'WhatIsIncluded' | translator: 'base'">
                         Your PSP record includes five years of crash and three years of roadside inspection data from
                         the FMCSA Motor Carrier Management Information System (MCMIS) database.
                    </p>
                    <p [innerHtml]="'WhatYouNeed' | translator: 'base'">
                         What youll need:
                    </p>
                    <ul>
                         <li [innerHtml]="'NeedDLNum' | translator: 'base'">
                              Your current driver's license number;</li>
                         <li [innerHtml]="'PaymentOptions' | translator: 'base'"
                             *ngIf="!service.justSubscribe">
                              A credit card (<i class="fab fa-cc-visa"
                                 title="Visa"
                                 aria-hidden="true"></i> Visa, <i class="fab fa-cc-mastercard"
                                 title="MasterCard"
                                 aria-hidden="true"></i> MasterCard,
                              <i class="fab fa-cc-discover"
                                 aria-hidden="true"
                                 title="Discover"></i> Discover, or <i class="fab fa-cc-amex"
                                 aria-hidden="true"
                                 title="American Express"></i> American
                              Express) or PayPal account;
                         </li>
                         <li [innerHtml]="'NeedEmail' | translator: 'base'">
                              A valid email address;</li>
                         <li [innerHtml]="'NeedDLHistory' | translator: 'base'">
                              For your full history, each driver's license number you've held in the last five years;
                              and
                         </li>
                         <li >
                              <span [innerHtml]="'NeedPdfReader1' | translator: 'base'">A way to view PDF documents. (Like the </span>
                              <a href="https://get.adobe.com/reader/" title="Adobe PDF" target="blank" name="pdf-reader">
                                   <span [innerHtml]="'NeedPdfReader2' | translator: 'base'">free PDF reader</span>
                              </a>).
                         </li>
                    </ul>
                    <p [innerHtml]="'CostOfRecordCheck' | translator: 'base'"
                       *ngIf="!service.justSubscribe">
                         <strong>A PSP record costs $10.</strong> This fee includes a search on your current commercial
                         driver's license
                         record, and/or any commercial driver's license you have held during the last five years. You
                         need to provide the
                         license number and license state for each license.
                    </p>
                    <p [innerHtml]="'RequestProcessingTime' | translator: 'base'"
                       *ngIf="!service.justSubscribe">
                         Your record request will take just a minute or two, and you will be able to view your record
                         on-screen or as a PDF.
                         You can save or print your record to keep it permanently. If you would like to print your PSP
                         record, please have a
                         printer ready.</p>
                    <p [innerHtml]="'RequestReciept' | translator: 'base'"
                       *ngIf="!service.justSubscribe">
                         A receipt will be delivered to you instantly by email from noreply&#64;Info.Tylerapp.com.
                    </p>
                    <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                         <div class="btn-group"
                              role="group">
                              <a [routerLink]="wizard.continueLinkRoute(_step)"
                                 (click)="scrollToTop()"
                                 class="btn btn-primary btn-strong"
                                 [title]="'Continue' | translator: 'base'"
                                 [innerHtml]="'Continue' | translator: 'base'"
                                 name="driverNext"
                                 id="driverNext">
                                   Continue
                              </a>
                         </div>
                         <div class="btn-group"
                              role="group">
                              <a [routerLink]="wizard._cancelLinkRoute"
                                 class="btn btn-light"
                                 (click)="scrollToTop()"
                                 name="driverCancel"
                                 id="driverCancel"
                                 [innerHtml]="'Cancel' | translator: 'base'"
                                 [title]="'Cancel' | translator: 'base'">
                                   Cancel
                              </a>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="1"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>